var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNavUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#434345;opacity:0.01;isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-nav-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.17,
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.23,84a4,4,0,0,0,8,0V21l21.14,23.4A4,4,0,0,0,79.25,39l-26-28.8c-.11-.12-.23-.24-.35-.35a6.8,6.8,0,0,0-9.29,0q-.2.18-.36.36L17.31,39a4,4,0,1,0,5.88,5.42l21-23.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNavUp);
export default __webpack_public_path__ + "static/media/arrow-nav-up.83941211d117bbe600b061ea45c4720b.svg";
export { ForwardRef as ReactComponent };